import React, { useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { SendPostRequest } from "../../../http";
import Spinner from "../../Spinner";
import { formatDate, limitParagraphByCharLimit } from "../../../Helper/Helper";

function ListViewBlogsGrid() {
    const [blogsData, setBlogsData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0);
        getBlogsData();
    }, []);

    const getBlogsData = async () => {
        setLoading(true);
        try {
            const response = await SendPostRequest("blogs/list");
            setBlogsData(response?.data);
        } catch (error) {
            console.error("Error fetching blogs:", error);
        } finally {
            setLoading(false);
        }
    };

    const options = {
        loop: true,
        nav: false,
        dots: false,
        autoplay: true,
        autoplayTimeout: 2500,
        autoplayHoverPause: true,
        smartSpeed: 1000,
        margin: 30,
        responsive: {
            0: { items: 1 },
            600: { items: 1 },
            1000: { items: 1 },
        },
    };

    // Only render section if there is data and it's not loading
    return (
        <>
            {loading ? (
                <div
                    style={{ marginBottom: "100px" }}
                    className="d-flex align-items-center justify-content-center "
                >
                    <Spinner />
                </div>
            ) : blogsData?.length > 0 ? (
                <section id="services-section" className="services-section semi-dark pt-4 pb-0">
                    <div className="container">
                        <div className="row">
                            <div className="offset-md-2 col-md-8">
                                <div className="title-wrap text-center">
                                    <div className="section-title margin-bottom-60">
                                        <h2 className="section-title margin-top-5 mb-0 text-uppercase">
                                            Blogs
                                        </h2>

                                        <span className="section-border-bottom center"></span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <OwlCarousel className="service-main-wrapper" {...options}>
                                    {blogsData?.map((data, index) => (
                                        <div className="blog-main-wrap blog-list-style-1" key={index}>
                                            <div className="blog-inner h-100">
                                                <div className="media h-100">
                                                    <div className="blog-thumb relative">
                                                        <div
                                                            style={{
                                                                width: "460px",
                                                                height: "230px",
                                                                backgroundImage: `url(${data?.image})`,
                                                                backgroundSize: "cover",
                                                                backgroundPosition: "top center",
                                                                backgroundRepeat: "no-repeat",
                                                            }}
                                                            className="img-fluid"
                                                        ></div>

                                                        <div className="blog-overlay">
                                                            <Link
                                                                to={`/blog/detail/${data?.slug}`}
                                                                className="post-link"
                                                            >
                                                                <span className="icon-link icons"></span>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                    <div className="media-body align-self-center">
                                                        <div className="blog-list-details">
                                                            <div className="blog-title">
                                                                <h5 className="entry-title mb-2">
                                                                    <Link
                                                                        to={`/blog/detail/${data?.slug}`}
                                                                        className="blog-name"
                                                                        style={{ fontSize: "18px" }}
                                                                    >
                                                                        {data?.title}
                                                                    </Link>
                                                                </h5>
                                                            </div>
                                                            <div className="post-desc pb-1">
                                                                <p>
                                                                    {limitParagraphByCharLimit(
                                                                        data?.short_content || data?.content,
                                                                        350
                                                                    )}
                                                                    {(data?.short_content || data?.content)?.length > 350 ? "..." : ""}

                                                                </p>
                                                            </div>
                                                            <div className="post-meta">
                                                                <div className="blog-link list-view-blog-readmore">
                                                                    <Link
                                                                        to={`/blog/detail/${data?.slug}`}
                                                                        className="link"
                                                                    >
                                                                        Read More
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr className="black" />
                                            </div>
                                        </div>
                                    ))}
                                </OwlCarousel>
                            </div>
                        </div>
                    </div>
                </section>
            ) : null}
        </>
    );
}

export default ListViewBlogsGrid;
